import React from 'react';
import { X } from 'lucide-react';
import { cn } from '@smartphone-tycoon/shared-ui';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  children: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}

const modalSizes = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
};

export function Modal({
  isOpen,
  onClose,
  title,
  size = 'md',
  children,
  className,
  'data-testid': dataTestId,
}: ModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid={dataTestId}>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />

      <div
        className={cn(
          'relative transform rounded-theme bg-theme-bg-content text-left shadow-theme transition-all',
          'w-full mx-4 max-h-[calc(100vh-4rem)] flex flex-col',
          modalSizes[size],
          className
        )}
      >
        {title && (
          <div className="flex items-center justify-between border-b border-theme-border px-6 py-4 flex-shrink-0">
            <h3 className="text-lg font-medium text-theme-text-primary">{title}</h3>
            <button
              onClick={onClose}
              className="p-2 -m-2 text-theme-text-muted hover:text-theme-text-secondary focus:outline-none min-w-[44px] min-h-[44px] flex items-center justify-center"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        )}
        
        <div className="px-6 py-4 overflow-y-auto flex-1">
          {children}
        </div>
      </div>
    </div>
  );
}